/**
 * 坐标纠偏纯数学：WGS84（GPS/地球坐标）↔ GCJ02（国测局"火星坐标"）。
 *
 * 为什么单独一个文件：这两套坐标的换算原来长在 amapScene.js 里，
 * 而它是"高德底图 + three 叠加"时代的产物 —— 模型是 WGS84、高德底图是 GCJ02，
 * 直接叠加会横平偏移 300~500 米，必须先纠偏。
 * 拆掉高德底图之后，渲染链路不再需要它，但**校准面板仍在展示两种坐标**
 * （现场核对模型落在真实地块上时，工程/客户都会拿 GCJ02 的坐标去地图上查），
 * 所以保留这个无依赖的纯函数，而不是连显示一起删掉。
 */

const GCJ_A = 6378245.0
const GCJ_EE = 0.00669342162296594323

function transformLat(x, y) {
  let ret =
    -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
  ret += ((20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0) / 3.0
  ret += ((20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin((y / 3.0) * Math.PI)) * 2.0) / 3.0
  ret += ((160.0 * Math.sin((y / 12.0) * Math.PI) + 320.0 * Math.sin((y * Math.PI) / 30.0)) * 2.0) / 3.0
  return ret
}

function transformLon(x, y) {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
  ret += ((20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0) / 3.0
  ret += ((20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin((x / 3.0) * Math.PI)) * 2.0) / 3.0
  ret += ((150.0 * Math.sin((x / 12.0) * Math.PI) + 300.0 * Math.sin((x * Math.PI) / 30.0)) * 2.0) / 3.0
  return ret
}

/** WGS84 -> GCJ02，返回 [lon, lat]；境外无偏移时原样返回 */
export function wgs2gcj(lon, lat) {
  if (lon < 72.004 || lon > 137.8347 || lat < 0.8293 || lat > 55.8271) return [lon, lat]
  let dLat = transformLat(lon - 105.0, lat - 35.0)
  let dLon = transformLon(lon - 105.0, lat - 35.0)
  const radLat = (lat / 180.0) * Math.PI
  let magic = Math.sin(radLat)
  magic = 1 - GCJ_EE * magic * magic
  const sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / (((GCJ_A * (1 - GCJ_EE)) / (magic * sqrtMagic)) * Math.PI)
  dLon = (dLon * 180.0) / ((GCJ_A / sqrtMagic) * Math.cos(radLat) * Math.PI)
  return [lon + dLon, lat + dLat]
}
